import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";

import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";

import {  useNavigate } from "react-router-dom";
import LoadingOverlay from "../overlays/LoadingOverlay";
import { yearlyForm, quaterlyForm, monthlyForm } from "../../utils/SubmitContent/PaypalForms";

export default function QuillionzProUpgradeModal({ isOpen, onClose }) {
  // Add a new state variable to track the loading state
  const [isLoading, setIsLoading] = React.useState(false);
  const email = localStorage.getItem("email");
  // Function to handle closing the modal
  const handleModalClose = () => {
    onClose(); // Close the modal
    // Do any other logic you need before redirecting to "/"
  };

  const onTestPaymentClick = (type) => () => {
    testSubscribe('Quillionz Pro', type);
  }

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={isOpen}
        onClose={onClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
        className="bg-[00000080]"
      >
        <Fade in={isOpen}>
          <Box
            sx={{
              position: "fixed",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",

              //   backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // Set the height to 100% of the viewport height
            }}
          >
            <div className="bg-white  shadow-2xl rounded-lg  animate-fade-slide-down w-max h-[48%]">
              <div className="flex place-content-between mx-3 p-[0.35rem] pt-2 border-b">
                <h2 className="text-lg font-semibold text-center">
                  Subscribe To :
                </h2>
                {""}
                <Tooltip
                  title="Close"
                  arrow
                  placement="top"
                  TransitionComponent={Zoom}
                  TransitionProps={{ timeout: 300 }}
                >
                  <button
                    className="text-[#6c757d] text-lg hover:bg-[#edeeef] px-2 rounded-full "
                    onClick={handleModalClose}
                  >
                    <i className="fa-solid fa-xmark"></i>{" "}
                  </button>
                </Tooltip>
              </div>

              {/* TODO : Piyush ji, the actual Paypal Payment Links for subscriptions have not been incorporated yet. */}
              {/* Subscribe ($99.99/Year) Button */}
              {
              !process.env.REACT_APP_TEST_MODE && <div className="text-center px-6 py-2">
                <div>
                  <div className="w-auto">
                    <Tooltip
                      title="Annual ($99.99)"
                      arrow
                      placement="top"
                      TransitionComponent={Zoom}
                      TransitionProps={{ timeout: 300 }}
                    >
                      {yearlyForm(email)}
                    </Tooltip>
                  </div>

                  <div className="mt-1">
                    ---------------- OR -----------------
                  </div>
                </div>

                {/* Subscribe ($29.99/Quarter) Button*/}
                <div>
                  <div>
                    <Tooltip
                      title="Quarterly ($29.99)"
                      arrow
                      placement="top"
                      TransitionComponent={Zoom}
                      TransitionProps={{ timeout: 300 }}
                    >
                      {quaterlyForm(email)}
                    </Tooltip>
                  </div>

                  <div className="mt-1">
                    ---------------- OR -----------------
                  </div>
                </div>

                {/* Subscribe ($14.99/Month) Button*/}
                <div className="pb-3">
                  <Tooltip
                    title=" Monthly ($14.99)"
                    arrow
                    placement="top"
                    TransitionComponent={Zoom}
                    TransitionProps={{ timeout: 300 }}
                  >
                    {monthlyForm(email)}
                  </Tooltip>
                </div>
              </div>
              }

              {process.env.REACT_APP_TEST_MODE && 
                 <div className="flex flex-col text-center px-6 py-2 ">
                    <button type="button" onClick={onTestPaymentClick('annual')} className="mt-2 hover:opacity-90 bg-[#f4833d] text-white px-4 py-2 rounded w-full">Annual 99.99 $</button>
                    <div className="mt-1 italic opacity-[50%]">
                    ---------------- OR -----------------
                  </div>
                    <button type="button" onClick={onTestPaymentClick('quarter')} className="mt-2 hover:opacity-90 bg-[#f4833d] text-white px-4 py-2 rounded w-full">Quarterly 29.99 $</button>
                    <div className="mt-1 italic opacity-[50%]">
                    ---------------- OR -----------------
                  </div>
                    <button type="button" onClick={onTestPaymentClick('monthly')} className="mt-2 hover:opacity-90 bg-[#f4833d] text-white px-4 py-2 rounded w-full">Monthly 14.99 $</button>
                 </div>
              }


              {/* Loading overlay */}
              {isLoading && <LoadingOverlay />}
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}


async function testSubscribe(product, type) {
  const email = localStorage.getItem("email")
  const custom = "Quillionz_"+email+"_"+product;	
  const res = await fetch(
    `${process.env.REACT_APP_API_URL}/paypal/user/subscription?UserId=${custom}&PaymentStatus=Completed&TransactionId=12L10404LW000652H&SubscriptionTransactionId=6VCM5KMYH9TVS&Amount=${type === "quarter" ? "USD 29.99" : (type === "monthly" ? "USD 14.99" : "USD 99.99")}&Buyer=${email}&Street=Delhi Street&Country=IN&City=Pune&Address1=SEZ Siddhant&Address2=Maharashtra&ResidenceCountry=IN&FirstName=Piyush&LastName=Saini&Txntype=subscr&ReceiptId=RCT334&TxnId=44553FXXS&PaymentDate=&Tax=&PaymentGross=14.99&Shipping=&ItemName1=GPT&Quantity1=1&MCShipping=&NumCartItems=1&MCGross=&MCGross1=&AddressStatus=confirmed&Zip=4455343&Phone=666644556&State=Maharastra`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    });
    await res.json();
    window.location.href = window.location.href + '?PayerID=M8G3GS7745C5W';  
}